var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComedy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_1896",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3999 23.4V0.600071H0.6V23.4H23.3999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6109 16.7431C19.6109 18.9454 17.0994 22 12.2132 22C7.30537 22 4.82031 18.9608 4.82031 16.7598C4.82031 15.5104 5.62106 14.5311 7.23392 14.5311C9.6345 14.5311 9.72355 17.0207 12.2132 17.0207C14.7028 17.0207 14.8021 14.5311 17.1924 14.5311C18.8129 14.5311 19.6109 15.5017 19.6109 16.7431Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50195 17.3703C8.19851 18.1756 9.46764 19.5104 12.2138 19.5104C14.9356 19.5104 16.209 18.1969 16.9104 17.3903",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99023 14.7821V12C5.99023 8.56825 8.78256 5.73443 12.2143 5.73443C15.646 5.73443 18.4384 8.56825 18.4384 12V14.7779",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47852 6.98236V5.73448C8.47852 3.67199 10.1505 2.00004 12.213 2.00004C14.2754 2.00004 15.9474 3.67199 15.9474 5.73448V6.98236",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72333 10.7551C9.72333 10.7551 9.41213 10.1327 9.10092 10.1327C8.78972 10.1327 8.47852 10.7551 8.47852 10.7551",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7033 10.7552C14.7033 10.7552 15.0145 10.1328 15.3257 10.1328C15.6369 10.1328 15.9482 10.7552 15.9482 10.7552",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7039 14.5311C14.7039 15.9061 13.5892 17.0208 12.2142 17.0208C10.8393 17.0208 9.72461 15.9061 9.72461 14.5311C9.72461 13.1561 10.8393 12 12.2142 12C13.5892 12 14.7039 13.1561 14.7039 14.5311Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9473 6.35685C15.9473 5.3256 16.7832 4.48963 17.8145 4.48963C18.6583 4.48963 19.3632 5.05307 19.5945 5.82166C20.3631 6.05295 20.9265 6.79929 20.9265 7.64315C20.9265 8.12357 20.74 8.5571 20.442 8.88797C20.74 9.21884 20.9265 9.65236 20.9265 10.1328C20.9265 11.164 20.0905 12 19.0593 12C18.8407 12 18.6309 11.9624 18.436 11.8934",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47925 6.35682C8.47925 5.32557 7.64328 4.4896 6.61203 4.4896C5.76817 4.4896 5.06332 5.05304 4.83203 5.82163C4.06344 6.05292 3.5 6.79926 3.5 7.64312C3.5 8.12354 3.68651 8.55706 3.98456 8.88794C3.68651 9.21881 3.5 9.65233 3.5 10.1327C3.5 11.164 4.33598 12 5.36722 12C5.58581 12 5.7956 11.9624 5.9905 11.8934",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComedy);
export default __webpack_public_path__ + "static/media/Comedy.9d5145db53ac34f7a6c5b07401fbfcf6.svg";
export { ForwardRef as ReactComponent };